import type { ClassValue } from 'clsx';

import { clsxm } from '@vs-shop/utils';

import {
  EmptyState,
  EmptyStateBody,
  EmptyStateDescription,
  EmptyStateTitle,
  EmptyStateVariant,
} from '@vs-shop/commerce-ui/emptyState';
import { Button } from '@vs-shop/ui/button';

import { Url } from '../../../../../route/router';

import { getMemoizedIntlShapeWithDefaultLocale } from '../../../../../utils/intl';

import Link from '@vs-shop/image-link/Link';

type Props = {
  className?: ClassValue;
};

export default function ArticlesEmpty({ className }: Props) {
  const intl = getMemoizedIntlShapeWithDefaultLocale();
  return (
    <EmptyState
      variant={EmptyStateVariant.STATED}
      role="status"
      className={clsxm('gap-6 py-12 lap:py-24', className)}
    >
      <EmptyStateBody>
        <EmptyStateTitle>
          {intl.formatMessage({
            id: 'component.server.page.article.overview.articlesEmpty.heading',
            defaultMessage: 'Nenalezeny žádné články',
          })}
        </EmptyStateTitle>
        <EmptyStateDescription>
          {intl.formatMessage({
            id: 'component.server.page.article.overview.articlesEmpty.description',
            defaultMessage: 'Zkuste změnit sekci, nebo se vraťte na přehled všech článků',
          })}
        </EmptyStateDescription>
      </EmptyStateBody>
      <Button render={<Link href={Url.articles} />} variant="primary" className="text-lg">
        {intl.formatMessage({
          id: 'component.server.page.article.overview.articlesEmpty.showAllArticles',
          defaultMessage: 'Zobrazit všechny články',
        })}
      </Button>
    </EmptyState>
  );
}
